type Props = { size?: number }

/** Right-pointing arrow; styled rules flip it (scaleX(-1)) to point left for RTL. */
const ChevronIcon = ({ size = 12 }: Props) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <path d="M5 12h14M13 6l6 6-6 6" />
  </svg>
)

export default ChevronIcon
